module.exports = __webpack_public_path__ + "img/background.6caa66e0.png";